<template>
  <v-menu
    bottom
    left
    offset-y
  >
    <template #activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        class="mt-n3"
        v-on="on"
      >
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>

    <v-list
      dense
      min-width="160"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          class="mt-n3"
          v-on="on"
        >
          <v-icon>mdi-dots-horizontal</v-icon>
        </v-btn>
      </template>

      <v-list
        dense
        min-width="160"
      >
        <v-list-item
          dense
          exact
          @click="toggleProjectPinnig(project)"
        >
          {{ project.pinned ? 'Odepnij' : 'Przypnij' }}
        </v-list-item>

        <v-list-item
          dense
          exact
          :to="projectDetailsRoute(project)"
        >
          Szczegóły
        </v-list-item>

        <v-list-item
          dense
          exact
          :to="{ name: 'project-metrics', params: { id: project.id } }"
        >
          Metryka
        </v-list-item>

        <v-list-item
          v-if="deletePermitted"
          dense
          link
          exact
          @click="$emit('delete')"
        >
          Usuń
        </v-list-item>
      </v-list>
    </v-list>
  </v-menu>
</template>

<script>
import projectFormattedInfo from '@/mixins/projectFormattedInfo.vue';
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
    deletable: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [
    projectFormattedInfo, // projectDetailsRoute
  ],
  computed: {
    ...mapState('auth', [
      'user',
    ]),
    deletePermitted() {
      const { userId, status } = this.project;
      const isOwnDraft = status === 'Wersja robocza' && userId === this.user.id;
      return isOwnDraft || this.deletable;
    },
  },
  methods: {
    ...mapActions('projects', [
      'toggleProjectPinnig',
    ]),
  },
};
</script>
